// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.module-news {
  display: inline-block;
}
.module-news .slider {
  margin-left: 40px;
  padding-bottom: 48px;
  width: 570px;
}
.module-news .slider > div {
  background: none;
  border: none;
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/NewsSlider/less/index.less"],"names":[],"mappings":"AAGA;EACC,qBAAA;AAFD;AACA;EAIE,iBAAA;EACA,oBAAA;EACA,YAAA;AAFF;AAIE;EACC,gBAAA;EACA,YAAA;EACA,UAAA;AAFH","sourcesContent":["@import (reference) \"../../../less/variables\";\n@import (reference) \"../../../less/mixins\";\n\n.module-news {\n\tdisplay: inline-block;\n\n\t.slider {\n\t\tmargin-left: @gutter*5;\n\t\tpadding-bottom: @gutter*6;\n\t\twidth: 570px;\n\n\t\t&>div {\n\t\t\tbackground: none;\n\t\t\tborder: none;\n\t\t\tpadding: 0;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
